export default __webpack_public_path__ + "media/color/spank-a8d93592.svg";